import { render, staticRenderFns } from "./LoadingShadow.vue?vue&type=template&id=229ae982&scoped=true"
var script = {}
import style0 from "./LoadingShadow.vue?vue&type=style&index=0&id=229ae982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229ae982",
  null
  
)

export default component.exports